import appConfig from '@nerdwallet/app-config';

import { VERTICALS } from './constants';

const TABS = [
  VERTICALS.CREDIT_CARD,
  VERTICALS.TRAVEL,
  VERTICALS.SMALL_BUSINESS,
  VERTICALS.PERSONAL_LOANS,
  VERTICALS.BANKING,
  VERTICALS.MORTGAGES,
  VERTICALS.INSURANCE,
  VERTICALS.INVESTING,
  VERTICALS.STUDENT_LOANS,
];

const verticalComparisonContent = {
  // to break title into two lines, add \n where you want the lines to split
  title: 'Make smart decisions with\nside-by-side comparisons',
  backgroundImageUrl: `${appConfig.ASSETS_URL}/images/homepage/tab1-background.svg`,
  tabs: TABS,
};

export default verticalComparisonContent;
